/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function SpaceLink({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#SpaceLink_svg__a)"><path d="M0 0h16v16H0z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M8.629 2.099a6.5 6.5 0 1 0 5.308 5.496M3.5 8.5h8M5.5 5.5h4M5.5 11.5h4M11.594 1H15m0 0v3.406M15 1l-3.406 3.406" /></g><defs><clipPath id="SpaceLink_svg__a"><path d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;